// compare: ham kiem tra
const checkItemInList = (list, item, compare) => {
    for (let index = 0; index < list.length; index++)
        if (compare(list[index], item)) return true
    return false
}

const insertItemToList = (list, item) => {
    list.push(item)
    return list
}

// compare: ham tra ve true thi update item tai vi tri do
const updateItemInList = (list, item, compare) => {
    let newList = []
    for (let index = 0; index < list.length; index++) {
        let current = list[index]
        if (compare(list[index], item)) {
            current[index] = item
        }
        newList.push(current)
    }
    return newList
}

/// is Delete: ham kiem tra xem co delete k
const deleteItemInList = (list, isDelete) => {
    let newList = []
    for (let index = 0; index < list.length; index++) {
        let current = list[index]
        if (!isDelete(list[index])) newList.push(current)
    }
    return newList
}

// isSelect: ham lua chon
const getListItemInList = (list, isSelect) => {
    let newList = []
    for (let index = 0; index < list.length; index++) {
        let current = list[index]
        if (isSelect(list[index])) newList.push(current)
    }
    return newList
}

export default {
    checkItemInList,
    insertItemToList,
    updateItemInList,
    deleteItemInList,
    getListItemInList,
}
